import { defineStore } from 'pinia'


export const useThemeStore = defineStore('themeStore', () => {
  const reset = ()=>{}
  return {reset}
})
